import { render, staticRenderFns } from "./RepairPictures.vue?vue&type=template&id=687230e4&scoped=true"
import script from "./RepairPictures.vue?vue&type=script&lang=js"
export * from "./RepairPictures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687230e4",
  null
  
)

export default component.exports